import { currentWritable, useThrelte } from '@threlte/core';
import { setContext } from 'svelte';
import { Raycaster, Vector2 } from 'three';
import { getDefaultComputeFunction } from './defaults';
import { injectInteractivityPlugin } from './plugin';
import { setupInteractivity } from './setupInteractivity';
const interactivity = (options) => {
    const state = {
        enabled: currentWritable(options?.enabled ?? true),
        pointer: currentWritable(new Vector2()),
        pointerOverTarget: currentWritable(false),
        lastEvent: undefined,
        raycaster: new Raycaster(),
        initialClick: [0, 0],
        initialHits: [],
        hovered: new Map(),
        interactiveObjects: [],
        target: currentWritable(options?.target ?? useThrelte().renderer.domElement),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        compute: () => { },
        filter: options?.filter
    };
    state.compute = options?.compute ?? getDefaultComputeFunction(state);
    setContext('threlte-interactivity-context', state);
    injectInteractivityPlugin();
    setupInteractivity(state);
    return state;
};
// exports
export { useInteractivity } from './hook';
export { interactivity };
